import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { BOOKS_BY_IDS_API } from '../../api/endpoint';
import { Book } from '../../types';
import { Typography } from '@mui/material';
import axiosInstance from '../../api/axiosConfig';
import createAxiosInstance from '../../api/axiosConfig';
import style from './style.module.css';

const UserBooks = () => {
  const location = useLocation();
  const { userDetail, userId } = location.state || {};
  const [pageKey, setPageKey] = useState('');
  const [booksData, setBooksData] = useState<any>([]);

  const fetchUserBooks = async () => {
    try {
      const axiosInstance = createAxiosInstance(false);
      const response = await axiosInstance.get(`${BOOKS_BY_IDS_API}?userId=${userId}&page=${pageKey}&count=9`);

      const bookIds = response.data.data.map((book: Book) => ({
        book_id: book.book_id,
        user_id: book.user_id
      }));

      if (bookIds.length > 0) {
        const bookDetailsResponse = await axiosInstance.post(BOOKS_BY_IDS_API, {
          targetIds: bookIds
        });
        if (response) {
          setBooksData((prevUserData: any) => [...prevUserData, ...bookDetailsResponse.data.data]);
        }
      }

      if (response.data.page) {
        setPageKey(response.data.page);
      }
    } catch (error) {
      console.error('Error fetching user books:', error);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchUserBooks();
    }
  }, []);

  return (
    <div>
      <div className={style['grid-container']}>
        {booksData && booksData.length > 0 ? (
          booksData.map((item: any, index: number) => {
            const coverName = item.cover?.[0]?.name || item.chapters?.[0]?.cover?.[0]?.name; // Use book cover first, then fallback to chapter cover
            const imageSrc = coverName
              ? `${process.env.REACT_APP_DEFAULT_AVATAR}/${item.user_id}/BOOKS/IMAGES/medium/${coverName}`
              : '/default-cover.jpg';
            return (
              <div key={index} className={style['grid-item-books']}>
                <div className={style['book-frame']} style={{ position: 'relative' }}>
                  <img src={imageSrc} alt={item.title || 'Untitled Book'} />
                  <div
                    style={{
                      position: 'absolute',
                      bottom: '40%',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      background: 'tranparent',
                      color: 'white',
                      padding: '5px 10px',
                      borderRadius: '15px',
                      textAlign: 'center',
                      width: '150px',
                      height: '83px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backdropFilter: 'blur(45px)',
                      backgroundImage: 'url(imageSrc)'
                    }}>
                    <Typography style={{ fontSize: '14px', fontWeight: 'bold', textAlign: 'center' }}>
                      {item.title}
                    </Typography>
                  </div>
                </div>

                <div className={style['book-details']}>
                  <div style={{ padding: '20px' }}>
                    <Typography style={{ fontSize: '14px', color: 'white', fontFamily: 'Baloo2', fontWeight: 500 }}>
                      Author:
                    </Typography>
                    <Typography
                      style={{
                        fontSize: '18px',
                        color: 'white',
                        fontFamily: 'Baloo2',
                        fontWeight: 800
                      }}>
                      Rubashree
                    </Typography>
                  </div>
                  <div style={{ padding: '20px' }}>
                    <Typography
                      style={{
                        fontSize: '14px',
                        color: 'white',
                        fontFamily: 'Baloo2',
                        fontWeight: 500,
                        whiteSpace: 'nowrap'
                      }}>
                      Date of Publication:
                    </Typography>
                    <Typography
                      style={{
                        fontSize: '18px',
                        color: 'white',
                        fontFamily: 'Baloo2',
                        fontWeight: 800,
                        textAlign: 'center'
                      }}>
                      {item.updated_at.split('T')[0]}
                    </Typography>
                  </div>
                  <div style={{ padding: '20px' }}>
                    <Typography style={{ fontSize: '14px', color: 'white', fontFamily: 'Baloo2', fontWeight: 500 }}>
                      Genre:
                    </Typography>
                    <Typography
                      style={{
                        fontSize: '18px',
                        color: 'white',
                        fontFamily: 'Baloo2',
                        fontWeight: 800
                      }}>
                      {item.type}
                    </Typography>
                  </div>
                  <div style={{ padding: '20px' }}>
                    <Typography style={{ fontSize: '14px', color: 'white', fontFamily: 'Baloo2', fontWeight: 500 }}>
                      Pages:
                    </Typography>
                    <Typography
                      style={{
                        fontSize: '18px',
                        color: 'white',
                        fontFamily: 'Baloo2',
                        fontWeight: 800
                      }}></Typography>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div>
            <Typography style={{ fontFamily: 'Baloo2', color: 'white' }}>
              You haven&apos;t created any Books yet!
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};
export default UserBooks;
